import { Navigate, useParams, useSearchParams } from "react-router-dom";

/** Legacy route — compliance lives under Settings. */
export default function ComplianceCenter() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const campaignId = searchParams.get("campaign_id");
  const target = campaignId
    ? `/corporate/${id}/settings?tab=compliance&campaign_id=${encodeURIComponent(campaignId)}`
    : `/corporate/${id}/settings?tab=compliance`;

  return <Navigate to={target} replace />;
}
